module.exports = __webpack_public_path__ + "static/media/onelife_logo.af13831c.png";